import { Redirect } from "react-router-dom";
import { RedirectProps } from "react-router";
import useQuery from "utils/hooks/useQuery";

interface RedirectWithQueryProps extends RedirectProps {
  to: string;
  queryKeysToDelete?: string[];
  queryToAppend?: Record<string, string>;
}

const RedirectWithQuery = ({
  to,
  queryKeysToDelete,
  queryToAppend,
  ...props
}: RedirectWithQueryProps) => {
  const currentSearchParams = useQuery();

  const getParsedUrl = (url: string) => {
    try {
      return new URL(url);
    } catch (e) {
      return null;
    }
  };

  let parsedDestUrl = getParsedUrl(to);
  if (!parsedDestUrl) {
    const destUrl = `${window.location.origin}${to}`;
    parsedDestUrl = getParsedUrl(destUrl);
  }

  let dest: string | { pathname: string; search: string } = to;

  if (parsedDestUrl) {
    try {
      let updatedSearchParams = {
        ...Object.fromEntries(currentSearchParams),
        ...Object.fromEntries(parsedDestUrl.searchParams),
      };
      if (!!queryToAppend) {
        updatedSearchParams = {
          ...updatedSearchParams,
          ...queryToAppend,
        };
      }
      queryKeysToDelete?.forEach(
        (queryKey) => delete updatedSearchParams[queryKey]
      );
      dest = {
        pathname: parsedDestUrl.pathname,
        search: new URLSearchParams(updatedSearchParams).toString(),
      };
    } catch (e) {}
  }

  return <Redirect to={dest} {...props} />;
};

export default RedirectWithQuery;
